export default __webpack_public_path__ + "static/media/overreach1.0a76a82d.png";